import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    messages: [],
    danmakus: [],
    aiLoading: false,
    viewerCount: 0,
    isLive: false,
  },
  reducers: {
    addMessage(state, action) {
      state.messages.push(action.payload);
      // 保留最近 200 条消息
      if (state.messages.length > 200) {
        state.messages = state.messages.slice(-200);
      }
    },
    addDanmaku(state, action) {
      state.danmakus.push(action.payload);
      // 保留最近 50 条弹幕
      if (state.danmakus.length > 50) {
        state.danmakus = state.danmakus.slice(-50);
      }
    },
    removeDanmaku(state, action) {
      state.danmakus = state.danmakus.filter((d) => d.id !== action.payload);
    },
    setAiLoading(state, action) {
      state.aiLoading = action.payload;
    },
    setViewerCount(state, action) {
      state.viewerCount = action.payload;
    },
    setIsLive(state, action) {
      state.isLive = action.payload;
    },
    clearMessages(state) {
      state.messages = [];
      state.danmakus = [];
    },
  },
});

export const {
  addMessage,
  addDanmaku,
  removeDanmaku,
  setAiLoading,
  setViewerCount,
  setIsLive,
  clearMessages,
} = chatSlice.actions;

export default chatSlice.reducer;
